export * from './formatted-tel.pipe';
export * from './is-complete-name-pipe.pipe';
export * from './is-tel.pipe';
export * from './only-numbers.pipe';
export * from './pipes.module';
